import { render, staticRenderFns } from "./IconMoon.vue?vue&type=template&id=836145a8"
import script from "./IconMoon.vue?vue&type=script&lang=js"
export * from "./IconMoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports